import React, { useEffect, useState } from "react";
import { http, fmt } from "@/lib/api";
import { VideoCard } from "@/components/VideoCard";
import { YT } from "@/constants/testIds";

export default function Channel() {
  const [channel, setChannel] = useState(null);
  const [videos, setVideos] = useState([]);
  const [subscribed, setSubscribed] = useState(false);

  useEffect(() => {
    let alive = true;
    Promise.all([
      http.get(`/channel`),
      http.get(`/videos`),
    ]).then(([c, v]) => {
      if (!alive) return;
      setChannel(c.data);
      setVideos(v.data || []);
    });
    return () => {
      alive = false;
    };
  }, []);

  if (!channel) {
    return <div style={{ padding: 24 }}>Loading channel…</div>;
  }

  return (
    <div data-testid={YT.channelPage}>
      <div className="yt-channel-banner" data-testid={YT.channelBanner}>
        {channel.banner ? (
          <img src={channel.banner} alt={`${channel.name} banner`} />
        ) : (
          <div
            style={{
              height: "100%",
              background:
                "linear-gradient(135deg, #555 0%, #2a2a2a 100%)",
            }}
          />
        )}
      </div>
      <div className="yt-channel-head">
        {channel.avatar ? (
          <img
            src={channel.avatar}
            alt={channel.name}
            className="yt-avatar"
          />
        ) : (
          <div
            className="yt-avatar"
            style={{ background: "#999" }}
          />
        )}
        <div>
          <div style={{ fontSize: 18, fontWeight: "bold", color: "#222" }}>
            {channel.name}
          </div>
          <div style={{ color: "#555", marginTop: 2 }}>
            @{channel.handle}
          </div>
          <div
            style={{ color: "#666", marginTop: 4, fontSize: 11 }}
            data-testid={YT.channelSubs}
          >
            <b>{channel.subscribers_label}</b> subscribers &middot;{" "}
            <b>{fmt.views(channel.total_views)}</b> total views{" "}
            {channel.joined ? `· Joined ${channel.joined}` : null}
          </div>
          {channel.description ? (
            <p
              style={{
                marginTop: 8,
                color: "#333",
                fontSize: 12,
                lineHeight: 1.45,
                maxWidth: 600,
              }}
            >
              {channel.description}
            </p>
          ) : null}
        </div>
        <button
          className={`yt-btn ${subscribed ? "" : "yt-btn-red"}`}
          onClick={() => setSubscribed((s) => !s)}
          data-testid={YT.subscribeBtn}
          style={{ minWidth: 110, fontSize: 13, padding: "5px 12px" }}
        >
          {subscribed ? "✔ Subscribed" : "+ Subscribe"}
        </button>
      </div>

      <div className="yt-section" style={{ marginTop: 12 }}>
        <div className="yt-section-title">Uploads ({videos.length})</div>
        <div className="yt-section-body">
          <div className="yt-grid">
            {videos.map((v) => (
              <VideoCard key={v.video_id} video={v} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
